// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6a-0";
export var startPickingButton = "_6a-1";